var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconHomeType = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 25h26M8.313 25V5.55M4.656 13c0-3.886.813-7.035 3.657-7.035 2.843 0 3.656 3.149 3.656 7.034",
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.406 13H15.22c0-3.886-3.092-7.035-6.906-7.035-3.815 0-6.907 3.149-6.907 7.034ZM10.344 22.518h10.562L23.344 25M12.781 22.518 10.344 25M14.406 22.517l-3.656-3.724M18.469 22.517l-1.625-1.656H12.78M18.063 5.139c2.437 0 2.843 1.655 2.843 1.655s.407-1.655 2.844-1.655M20.906 6.793v.414",
  stroke: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.543 5.548C13.656 2.874 16.252 1 19.283 1c4.038 0 7.312 3.335 7.312 7.448s-3.274 7.449-7.312 7.449a7.183 7.183 0 0 1-4.266-1.4",
  stroke: "currentColor"
})));

export default SvgIconHomeType;